import { coachPaths } from "../routes/coach";
import { findAJobPaths } from "../routes/find-a-job";
import { hireTalentPaths } from "../routes/hire-talent";
import {
  getProfile,
  setActivePublicPanel,
  setProfile,
  setToken,
} from "./pip";
import { normalizeHireTalentProfile } from "./hireTalentProfile";
import { createSocketConnection } from "../redux/features/chat/socket";
import { fetchfreelancerProfile } from "../redux/features/find-a-job/actions/authAction";
import { fetchHireTalentProfile } from "../redux/features/hire-talent/actions/authAction";
import {
  setIsFindAJobModal,
  setRegisterStep,
} from "../redux/features/find-a-job/reducers/authReducer";
import {
  setIsHireTalentModal,
  setStartStep,
} from "../redux/features/hire-talent/reducers/authReducer";

export const handlePostLoginFlow = ({
  response,
  dispatch,
  navigate,
  onClose,
  source,
}) => {
  const payload = response?.data || response;
  const token = payload?.token;
  const userData = payload?.userData;
  const close = () => {
    if (typeof onClose === "function") {
      onClose();
    };
  };
  if (!userData) return;
  if (userData?.role == "COACH") {
    setToken("coach", token);
    setActivePublicPanel("coach");
    setProfile("coach", userData);
    close();
    navigate(coachPaths?.CoachDashboard);
  } else if (userData?.role == "OPEN_TALENT") {
    setToken("freelancer", token);
    setActivePublicPanel("freelancer");
    setProfile("freelancer", userData);
    dispatch(fetchfreelancerProfile()).then((res) => {
      const data = res?.payload?.data;
      if (data) {
        const existing = getProfile("freelancer") || {};
        const merged = {
          ...data,
          full_name:
            data.full_name ||
            existing.full_name ||
            `${data.first_name || ""} ${data.last_name || ""}`.trim(),
          first_name: data.first_name || existing.first_name || data.full_name || "",
          last_name: data.last_name || existing.last_name || "",
        };
        setProfile("freelancer", merged);
      }
    });
    const freelancerSignupStep =
      Number(
        userData?.signup_step ||
          userData?.open_talent?.signup_step ||
          0
      ) || 0;
    const freelancerTalentType = String(
      userData?.open_talent?.talent_type || userData?.talent_type || ""
    ).toUpperCase();
    const isOpenTalentSignupFlow = source === "signup";
    const shouldOpenOnboarding =
      ["FREELANCER", "JOB_SEEKER"].includes(freelancerTalentType) &&
      ((freelancerSignupStep > 0 && freelancerSignupStep < 5) ||
        (isOpenTalentSignupFlow && freelancerSignupStep === 0));

    if (shouldOpenOnboarding) {
      close();
      dispatch(
        setRegisterStep(
          `profileStep${freelancerSignupStep > 0 ? freelancerSignupStep : 1}`
        )
      );
      dispatch(setIsFindAJobModal(true));
      return;
    }

    if (
      freelancerTalentType === "FREELANCER" &&
      userData?.active_subscription === false
    ) {
      close();
      dispatch(setRegisterStep("subscription"));
      dispatch(setIsFindAJobModal(true));
      return;
    }

    close();
    dispatch(setIsFindAJobModal(false));
    dispatch(setRegisterStep(1));
    createSocketConnection(token);
    navigate(findAJobPaths?.Dashboard);
  } else if (userData?.role == "HIRE_TALENT") {
    setToken("hire-talent", token);
    setActivePublicPanel("hire-talent");
    setProfile("hire-talent", userData);
    dispatch(fetchHireTalentProfile({ force: true })).then((res) => {
      const data = res?.payload?.data;
      const existing = getProfile("hire-talent") || {};
      const normalized = normalizeHireTalentProfile({
        ...existing,
        ...(data || {}),
        ...(userData?.hiretalent || {}),
      });
      const rawSignupStep =
        Number(
          normalized?.signup_step ||
            data?.signup_step ||
            userData?.signup_step ||
            normalized?.hiretalent?.signup_step ||
            data?.hiretalent?.signup_step ||
            userData?.hiretalent?.signup_step ||
            0
        ) || 0;
      const hasPrimaryContact = Boolean(
        normalized?.primary_contact_name ||
          normalized?.primary_contact_full_name ||
          normalized?.primary_contact_email ||
          normalized?.primary_contact_work_email
      );
      const hasProjectDetails = Boolean(
        normalized?.project_title ||
          normalized?.role_in_project ||
          normalized?.project_description
      );
      const hasWorkEnvironment = Boolean(
        normalized?.preferred_timezone ||
          normalized?.work_environment ||
          normalized?.work_enviroment ||
          normalized?.collaboration_type ||
          normalized?.types_of_collaboration
      );
      const isHireTalentOnboardingComplete = rawSignupStep === 4;
      const inferredStep = !hasPrimaryContact
        ? 2
        : !hasProjectDetails || !hasWorkEnvironment
          ? 3
          : 0;
      const startStep =
        isHireTalentOnboardingComplete
          ? 0
          : source === "signup"
          ? 2
          : rawSignupStep === 1
            ? 2
            : rawSignupStep === 2
              ? 3
              : rawSignupStep > 0 && rawSignupStep < 4
                ? Math.min(Math.max(rawSignupStep, 1), 3)
                : inferredStep;
      setProfile("hire-talent", normalized);

      if (startStep > 0 && startStep <= 3) {
        dispatch(setStartStep(startStep));
        dispatch(setIsHireTalentModal(true));
        if (source !== "signup") {
          close();
        }
        return;
      }

      dispatch(setIsHireTalentModal(false));
      createSocketConnection(token);
      navigate(hireTalentPaths?.Dashboard);
      close();
    });
  };
};
